import Addon from '../../../../shared/classes/addon';
import Background from '../../atoms/images/descriptionBackground';
import Corner from '../../../../shared/classes/corner';
import Logo from '../../atoms/images/channelLogo';
import LogoContainer from '../../atoms/container/descriptionChannelLogoContainer';
import MainContext from '../../../../shared/components/utils/context/mainContext';
import MaskLateral from '../../atoms/mask/descriptionMaskLateral';
import MaskVertical from '../../atoms/mask/descriptionMaskVertical';
import ParentalUtils from '../../../../shared/utils/parental';
import PhotoDefault from '../../../../shared/assets/images/png/photoDefault.png';
import Tick from '../../elements/addons/descriptionAddonTick';
import { useContext, useEffect, useState } from 'react';

const DESCRIPTION_TIME = 300;

export default function DescriptionBackground() {
  const { asset } = useContext(MainContext);
  const [background, setBackground] = useState<string | null>(null);
  const [logo, setLogo] = useState<string | null>(null);

  useEffect(() => {
    setBackground(null);
    setLogo(null);
    const imageTimeout = setTimeout(() => {
      setBackground(asset?.background || null);
      setLogo(
        asset?.channel?.logoWhite ||
          (asset as Addon | Corner)?.logoWhite ||
          (asset as Addon | Corner)?.logoColor ||
          null
      );
    }, DESCRIPTION_TIME);

    return () => {
      clearTimeout(imageTimeout);
    };
  }, [asset]);

  return (
    <>
      {background ? (
        <Background
          src={
            ParentalUtils.isAdultRestricted(asset) ? PhotoDefault : background
          }
        />
      ) : null}
      <MaskLateral />
      <MaskVertical />
      <LogoContainer>
        {logo ? (
          <Logo src={logo} disableWidth={true} displayFilter={true} />
        ) : null}
        {asset ? <Tick asset={asset as Addon} /> : null}
      </LogoContainer>
    </>
  );
}
